// extracted by mini-css-extract-plugin
module.exports = {"streaming":"video-streaming_streaming__BzWR2","chromecast":"video-streaming_chromecast__L_c5A","airplay":"video-streaming_airplay__257uz"};